/**
 * Absolute origin of the running app (scheme + host + port), e.g.
 * https://app.blindvalet.com or https://localhost:4200 with ng serve --ssl.
 * Read from the browser rather than the environment file so links always
 * match how the app was actually opened.
 */
export function appOrigin(): string {
  return window.location.origin;
}

/** Permanent club link: /join/{clubID}. Doubles as the club's bookmark. */
export function clubJoinUrl(clubID: string): string {
  return `${appOrigin()}/join/${clubID}`;
}
